export enum OnboardingType {
  NAVIGATION = 'NAVIGATION',
  TEXSTATE = 'TEXSTATE',
  PLANNING = 'PLANNING'
}
